import React from 'react';
import CustomNumberField from "./temp/CustomNumberField";
import {Field, useField} from 'formik';

export const ReportNumberField = ({ name, label, validate, ...props }) => {
  const [field] = useField(name)

  return (
    <Field
      component={CustomNumberField}
      name={name}
      label={label}
      value={field.value ?? ''}
      validate={validate}
      {...props}
    />
  );
};